module.exports = __webpack_public_path__ + "media/student_v2/assets/images/icon_alert-8f99146fc4d8d7c317cc6f8382643b5e.svg";